/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PersonalInformation.scss';

import { string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { ReactComponent as PdfIcon } from 'assets/icons/pdf.svg';
import { ReactComponent as WarningCircleIcon } from 'assets/icons/warning-circle.svg';
import ProfileLabeledInput from 'components/layouts/Preferences/ProfileLabeledInput';
import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesRowLabel from 'components/layouts/Preferences/shared/PreferencesRowLabel';
import BaseModalButton from 'components/shared/Modal/BaseModalButton';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { linkBuilder, preferencesLinks } from 'services/Externals';
import {
  getCustomerBirthday,
  getCustomerName,
  getCustomerTaxId
} from 'state/customer/CustomerSelectors';
import { getView, hasCollegeSavingsOnly } from 'state/view/ViewSelectors';

const LegalName = ({ legalName }) => (
  <span className="personal-information-row-value">{legalName}</span>
);

const SocialNumber = ({ socialSecurity }) => (
  <span className="personal-information-row-value">{socialSecurity}</span>
);

const DateOfBirth = ({ birthday }) => (
  <span className="personal-information-row-value">{birthday}</span>
);

const LegalNameWithPermissions = WithUserPermissions(LegalName);
const SocialWithPermissions = WithUserPermissions(SocialNumber);
const DOBWithPerimissions = WithUserPermissions(DateOfBirth);

const PersonalInformation = ({
  birthday,
  legalName,
  socialSecurity,
  hasCollegeSavingsOnly,
  view
}) => (
  <PreferencesRow>
    <PreferencesCol className="personal-information-title" col={3} mobile={12}>
      <PreferencesRowLabel label="Personal Information" />
      <BaseModalButton
        buttonClassName="download-pdf-icon"
        label={<WarningCircleIcon />}
        title="Personal Information">
        <a
          className="personal-information-name-change-form-modal"
          href={linkBuilder(preferencesLinks.nameChangeForm, view)}
          rel="noreferrer"
          target="_blank">
          <PdfIcon className="name-change-icon" />
          Name Change Form
        </a>
      </BaseModalButton>
    </PreferencesCol>
    <PreferencesCol
      className="personal-information-section"
      col={6}
      mobile={12}>
      <ProfileLabeledInput label="Legal Name" isReadOnly={true}>
        <LegalNameWithPermissions legalName={legalName} shouldMask />
      </ProfileLabeledInput>
      <ProfileLabeledInput label="Social Security" isReadOnly={true}>
        <SocialWithPermissions socialSecurity={socialSecurity} shouldMask />
      </ProfileLabeledInput>
      <ProfileLabeledInput label="Date of Birth" isReadOnly={true}>
        <DOBWithPerimissions birthday={birthday} shouldMask />
      </ProfileLabeledInput>
    </PreferencesCol>
    {!hasCollegeSavingsOnly && (
      <PreferencesCol col={3} mobile={12}>
        {!hasCollegeSavingsOnly && (
          <a
            className="personal-information-name-change-form"
            href={linkBuilder(preferencesLinks.nameChangeForm, view)}
            target="_blank"
            rel="noreferrer">
            <PdfIcon className="name-change-icon" />
            Name Change Form
          </a>
        )}
      </PreferencesCol>
    )}
  </PreferencesRow>
);

PersonalInformation.propTypes = {
  birthday: string.isRequired,
  legalName: string.isRequired,
  socialSecurity: string.isRequired
};

PersonalInformation.defaultProps = {
  birthday: '',
  legalName: '',
  socialSecurity: ''
};

const mapStateToProps = (state) => ({
  birthday: getCustomerBirthday(state),
  legalName: getCustomerName(state),
  socialSecurity: getCustomerTaxId(state),
  hasCollegeSavingsOnly: hasCollegeSavingsOnly(state),
  view: getView(state)
});

export default connect(mapStateToProps)(PersonalInformation);
